import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    [theme.breakpoints.up('sm')]: {
      flexGrow: 1,
      paddingLeft: theme.spacing(4),
      '& > h2:first-of-type': {
        marginTop: theme.spacing(1)
      }
    }
  }
}));

type Props = {
  children?: React.ReactNode;
  tab: unknown;
  currentTab: unknown;
};

const VerticalTabPanel = (props: Props) => {
  const { children, currentTab, tab, ...other } = props;
  const { classes } = useStyles();

  if (currentTab !== tab) {
    return null;
  }

  return (
    <div
      className={classes.wrapper}
      role="tabpanel"
      id={`vertical-tabpanel-${tab}`}
      aria-labelledby={`vertical-tab-${tab}`}
      {...other}
    >
      {children}
    </div>
  );
}

export default VerticalTabPanel;
